// extracted by mini-css-extract-plugin
export var legends = "Map-module--legends--37zUG";
export var colorBox = "Map-module--color-box--2jAUn";
export var mapContainer = "Map-module--map-container--JUChg";